// LIBRARIES //
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { CheckCircleFilled, MinusCircleFilled } from '@ant-design/icons';

// COMPONENTS //
import ExpandableActivityCard from './ExpandableActivityCard';
import Divider from 'components/ui/Divider';

// ASSETS //
import NoticeIcon from './assets/NoticeIcon.svg';

// HELPERS //
import { getTranslatedString } from 'helpers/i18n';
import { colors, iconColors } from 'helpers/ColorHelper';

const StyledDivider = styled(Divider)`
  margin-top: 15px;
  margin-bottom: 15px;
  height: 2px;
  background-color: rgba(0, 0, 0, 0.06);
`;

const StyledSubtitle = styled.p`
  font-size: 14px;
  margin: 0;
  color: ${colors.CHAR_COUNT};
`;

const StyledNoteText = styled.p`
  font-size: 16px;
  margin: 0;
  color: ${colors.MED_DARK_GRAY};
`;

const NoticeCard = ({ id, title, propertyName, noticeDate, noticeDetails, wasSentToUser }) => {
  const hiddenContent = noticeDetails && (
    <Fragment>
      <StyledSubtitle>
        {getTranslatedString('landlordPortal.tenantDetails.activity.noticeDetails')}
      </StyledSubtitle>
      <StyledNoteText>{noticeDetails}</StyledNoteText>
    </Fragment>
  );

  const handleClick = () => {
    if (id) {
      window.open(`/companies/notices/${id}`, '_blank');
    }
  };

  let subHeader = '';
  let Icon = <CheckCircleFilled style={{ color: iconColors.CHECK_CIRCLE_FILLED }} />;

  if (!wasSentToUser) {
    subHeader = getTranslatedString('landlordPortal.tenantDetails.activity.noticeNotSent');
    Icon = <MinusCircleFilled style={{ color: iconColors.MINUS_CIRCLE_FILLED }} />;
  }

  return (
    <ExpandableActivityCard
      icon={NoticeIcon}
      title={title}
      id={id}
      handleClick={handleClick}
      propertyName={propertyName}
      dateString={getTranslatedString('landlordPortal.tenantDetails.activity.sentOn', {
        noticeDate: noticeDate,
      })}
      rightSubHeader={subHeader}
      RightIcon={Icon}
      bodyContent={<StyledDivider />}
      hiddenContent={hiddenContent}
    />
  );
};

export default NoticeCard;
